import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseCardImportSetupModel } from '@app/models/system-settings/purchase-card-import-setup.model';

@Injectable()
export class PurchaseCardImportSetupService {
	endpointBase = '/api/payment-card-import-setup';

	constructor(private readonly http: HttpClient) {}

	getSetupByPaymentCardId(paymentCardId: number): Observable<any> {
		return this.http.get(this.endpointBase, {
			params: {
				paymentCardId: paymentCardId.toString(),
			},
		});
	}

	createOrUpdate(model: PurchaseCardImportSetupModel): Observable<any> {
		return this.http.post(this.endpointBase, model);
	}

	getLookups(): Observable<any> {
		return this.http.get(`${this.endpointBase}/lookups`);
	}
}
